module.exports = __webpack_public_path__ + "img/spiral-details2.fba514dd.png";